// src-brand/BrandApp.tsx — root KHUSUS toko brand (/). Provider minimal.
import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { LanguageProvider } from '../contexts/LanguageContext';
import { ToastProvider } from '../contexts/ToastContext';
import { SettingsProvider } from '../contexts/SettingsContext';
import { DialogProvider } from '../contexts/DialogContext';
import { FormLoadingFallback } from '../App/LoadingScreens';
import { PublicForceLight } from '../App/PublicForceLight';
import { onIdle } from '../utils/idleCallback';
import { initRum } from '../utils/rum';
import { lazyWithRetry } from '../utils/lazyWithRetry';

const BrandStorePage = lazyWithRetry(() => import('../pages/BrandStorePage'));

if (typeof window !== 'undefined') initRum();

const LazyPresence = React.lazy(() => import('../components/PublicPresenceTracker'));

const DeferredPresence: React.FC = () => {
  const [ready, setReady] = React.useState(false);
  React.useEffect(() => onIdle(() => setReady(true), 3000), []);
  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <LazyPresence />
    </Suspense>
  );
};

const BrandApp: React.FC = () => (
  <ErrorBoundary context="BrandApp">
    <LanguageProvider>
      <ToastProvider>
        <SettingsProvider>
          <DialogProvider>
            <BrowserRouter>
              <DeferredPresence />
              <Suspense fallback={<FormLoadingFallback />}>
                <Routes>
                  <Route path="/" element={<PublicForceLight><BrandStorePage /></PublicForceLight>} />
                  <Route path="*" element={<PublicForceLight><BrandStorePage /></PublicForceLight>} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </DialogProvider>
        </SettingsProvider>
      </ToastProvider>
    </LanguageProvider>
  </ErrorBoundary>
);

export default BrandApp;
